import { render, staticRenderFns } from "./choiceButton.vue?vue&type=template&id=146c5c36&scoped=true&"
import script from "./choiceButton.vue?vue&type=script&lang=js&"
export * from "./choiceButton.vue?vue&type=script&lang=js&"
import style0 from "./choiceButton.vue?vue&type=style&index=0&id=146c5c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146c5c36",
  null
  
)

export default component.exports